module.exports = __webpack_public_path__ + "img/16.30ff5cf5.png";